import React from 'react';
import { PropTypes } from 'prop-types';
import { Column } from 'components/shared/Layout';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { InfoLabel, InfoContainer } from './Info.styles';

const Info = ({ currency, value, price, labelId, className, dataId, fixed = false }) => (
  <InfoContainer className={className} data-cy={dataId} gutter="0px">
    <Column className="label" span={3}>
      <InfoLabel>
        <FormattedMessage id={labelId} />
      </InfoLabel>
      :
    </Column>
    {price || price === 0 ? (
      <>
        {!fixed ? (
          <>
            <Column className="value" data-testid={`count-${dataId}`} span={4} start={4}>
              {value}
            </Column>
            <Column className="price" data-testid={`price-${dataId}`} span={3} start={8}>
              <FormattedCurrency currency={currency} amount={price} />
            </Column>
          </>
        ) : (
          <>
            <Column className="price" data-testid={`price-${dataId}`} span={3} start={4}>
              <FormattedCurrency currency={currency} amount={price} />
            </Column>
          </>
        )}
      </>
    ) : (
      <Column data-testid={dataId} span={13} start={4}>
        {value}
      </Column>
    )}
  </InfoContainer>
);

Info.propTypes = {
  currency: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelId: PropTypes.string,
  className: PropTypes.string,
  dataId: PropTypes.string,
  fixed: PropTypes.bool
};

export default Info;
